import { createContext } from "react";
import type { AdornmentPosition } from "./BaseInputAdornment.tsx";

type BaseInputAdornmentContextValue = {
  position: AdornmentPosition;
  disabled?: boolean;
  /**
   * Ширина концевой ячейки в пикселях.
   *
   * Живёт в контексте, а не пропом у самой ячейки, потому что то же число
   * поле резервирует отступом под неё. Разъедутся они молча: ячейка шире
   * отступа накроет значение, уже отступа — оставит шов у края. Один
   * источник на оба.
   */
  width?: number;
};

export const BaseInputAdornmentContext =
  createContext<BaseInputAdornmentContextValue | null>(null);
